// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router' 
import api from './api/index.js' 
import store from '../store'
import './common/js/flexlble'
import './common/css/common.css'   

Vue.config.productionTip = false 
Vue.prototype.$store = store

// 图片服务器地址
// Vue.prototype.imgserver = 'http://cm.qingting1.com:22122/'//生产
// Vue.prototype.imgserver = 'http://cm-newpre.qingting1.com/file-server/'//演示
// Vue.prototype.imgserver = 'http://172.27.3.216/' //开发 
Vue.prototype.$api=api
/* eslint-disable no-new */  
new Vue({
  el: '#app',
	store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js